import { gql } from '@lcs/shared/api';

export const saveAllowedIpAddressMutation = gql`
   mutation SaveAllowedIpAddress($allowedIpAddress: AllowedIpAddressInput!) {
      allowedIpAddress: saveAllowedIpAddress(allowedIpAddress: $allowedIpAddress) {
         allowedIpAddressId
         ipAddress
         accountId
         qManageTicketId
         status
      }
   }
`;
